//ADDME move cookie state to sessionstorage, we don't need to transmit _c cookies on each request

import URLBuilder from 'dompack/extra/urlbuilder';
import * as dompack from 'dompack';
import * as domcookie from 'dompack/extra/cookie';
import * as whintegration from '@webhare-system/wh/integration';

const JSONRPC = require('@webhare-system/net/jsonrpc');

var defaultauth = null;

class WRDAuthenticationProvider
{
  constructor(options)
  {
    if(!options)
      options={};

    this.cookiename = 'cookiename' in options ? options.cookiename : "webharelogin";
    this.cookiepath = 'cookiepath' in options ? options.cookiepath : '/';
    this.samlidpreq = 'samlidpreq' in options ? options.samlidpreq : '';

    this.refresh();
  }

  refresh()
  {
    this.isloggedin = false;
    this.userinfo = null;
    this.logouturl = "";
    this.loginservice = new JSONRPC( { url: '/wh_services/wrd/auth' + (dompack.debugflags.aut ? "?wh-debug=aut" : "" )});

    var jsstate = domcookie.read(this.cookiename + '_j');
    var currentstate = domcookie.read(this.cookiename + '_c');

    if(dompack.debugflags.aut)
    {
      console.log("[aut] " + this.cookiename + "_j=" + jsstate);
      console.log("[aut] " + this.cookiename + "_c=" + currentstate);
    }
    if(!jsstate)
      return;

    if(!currentstate || currentstate.substr(0, jsstate.length) != jsstate)
    {
      var redirectto = new URLBuilder(location.href).update(this.cookiepath).update('.!wrd/auth/restoresession.shtml?back=' + encodeURIComponent(location.href));
      location.replace(redirectto);
      return;
    }
    else
    {
      if(dompack.debugflags.aut)
        console.log("[aut] looks like we're still logged in");

      this.isloggedin = true;
      if(currentstate.length > 1)
        try
        {
          this.userinfo = JSON.parse(currentstate.substr(jsstate.length));
        }
        catch(e)
        {
        }
/*
      var returnto = new URLBuilder(location.href).searchParams.get("wrdauth_returnto"); //FIXME is this still needed, now that we bounce against /wrd/gologin?
      if (returnto)
      {
        var cookiepathbase = new URLBuilder(location.href).update(this.cookiepath).toString();

        if (returnto.substr(0, cookiepathbase.length) == cookiepathbase)
        {
          var returnurl = new URLBuilder(returnto);
          returnurl.searchParams.set('wrdauth_returned', "loggedin");
          location.replace(returnurl);
        }
        else
        {
          location.replace(new URLBuilder(location.href).update('.!wrd/auth/exportsession.shtml?back=' + encodeURIComponent(returnto)));
        }
      }*/
    }
  }

  logout()
  {
    var back = this.logouturl ? new URLBuilder(location.href).update(this.logouturl).toString() : location.href;
    var redirectto = new URLBuilder(location.href).update(this.cookiepath).update('.!wrd/auth/logout.shtml?back=' + encodeURIComponent(back));
    location.replace(redirectto);
  }

  setupLoginForm(form)
  {
    if(form)
       form.addEventListener("submit", this.handleLoginForm.bind(this, form));
     else
       throw new Error("No such form");
  }
  handleLoginForm(form, event)
  {
    event.preventDefault();
    event.stopPropagation();

    var loginfield = form.querySelector('*[name="login"]');
    var passwordfield = form.querySelector('*[name="password"]');
    var persistentfield = form.querySelector('*[name="persistent"]');

    if(!loginfield)
      throw new Error("No field named 'login' found");
    if(!passwordfield)
      throw new Error("No field named 'password' found");

    var persistentlogin = persistentfield && persistentfield.checked;
    this._tryLogin(form, loginfield.value, passwordfield.value, { persistent: persistentlogin });
  }
  login(login, password, options)
  {
    options = {...options};
    return new Promise( (resolve, reject) =>
    {
      var url = new URLBuilder(location.href);

      var opts =
        { challenge:    url.searchParams.get("wrdauth_challenge") || ""
        , returnto:     url.searchParams.get("wrdauth_returnto") || ""
        , samlidpreq:   this.samlidpreq
        };

      return this.loginservice.request('Login'
                                       , [ location.href
                                         , login
                                         , password
                                         , Boolean(options.persistent)
                                         , opts
                                         ]
                                       , function(response)
                                         { //success handler
                                           resolve(response);
                                         }
                                       , function(error)
                                         {
                                           reject(error);//FIXME translate to exception
                                         }
                                       );
    });
  }
//ADDME do we have direct callers or can we _tryLogin this?
  _tryLogin(form, login, password, options)
  {
    let loginlock = dompack.flagUIBusy();
    if(form)
      form.classList.add("submitting");

    this.login(login, password, options).then( result => this.onLoginSuccess(loginlock, form, result) )
              .catch( error => this.onLoginFailure(loginlock, form, options, error));
  }
  onLoginSuccess(loginlock, form, response)
  {
    if(form)
      form.classList.remove("submitting");

    let completion = () => this._completeLoginSuccess(loginlock, response);
    dompack.dispatchCustomEvent(form || document,
                                'wh:wrdauth-onlogin',
                                { bubbles: true
                                , cancelable: true
                                , detail: { callback: completion, userinfo: response.userinfo }
                                , defaulthandler: completion
                                });
  }
  _completeLoginSuccess(loginlock, response)
  {
    loginlock.release();
    if(response.success)
    {
      if (response.submitinstruction)
      {
        whintegration.executeSubmitInstruction(response.submitinstruction);
        return;
      }

      //The user has succesfully logged in
      location.reload(true);
      return;
    }

    this.failLogin(/* FIXME? Locale.get('wh-common.authentication.loginfail') || */'The specified login data is incorrect.', response);
  }
  onLoginFailure(loginlock, form, options, code, msg)
  {
    if(form)
      form.removeClass("submitting");
    loginlock.release();

    this.failLogin(/* FIXME? Locale.get('wh-common.authentication.loginerror') || */'An error has occurred.', { code: code });
  }
  failLogin(message, response)
  {
    let cancelled = !dompack.dispatchCustomEvent(document, "wh:wrdauth-loginfailed",
        { bubbles: false
        , cancelable: true
        , detail:
            { message: message
            , code: response.code
            , data: response.data
            }
        });

    if(!cancelled)
    {
      /*
      if($wh.Popup && $wh.Popup.Dialog)
        new $wh.Popup.Dialog( { text: failevent.message, buttons: [{ result: 'ok', title: "Ok" }] });
      else*/
        alert(message);
    }
  }
  isLoggedIn()
  {
    return this.isloggedin;
  }
  getUserInfo()
  {
    return this.userinfo;
  }
  setLogoutURL(url)
  {
    this.logouturl = url;
  }

  startSAMLLogin(sp_tag, options)
  {
    options = options || {};
    var defer = dompack.createDeferred();

    this.loginservice.request('StartSAMLLogin'
                              , [ location.href, sp_tag, options ]
                              , defer.resolve
                              , defer.reject //FIXME translate to exception
                              );

    return defer.promise;
  }
}

WRDAuthenticationProvider.getDefaultAuth = function()
{
  return defaultauth;
};

if(dompack.debugflags.aut)
{
  var debuginfo = domcookie.read("wh-wrdauth-debug");
  if(debuginfo)
    debuginfo.split('\t').forEach( msg => console.warn("[aut] server: " + msg));
  domcookie.remove("wh-wrdauth-debug");
}

if(window.$wh && window.$wh.WRDAuthenticationProvider)
{
  console.log("Both designfiles wrd.auth and @webhare-wrd/auth are loaded. @webhare-wrd/auth will not activate");
}
else if(whintegration.config["wrd:auth"])
{
  defaultauth = new WRDAuthenticationProvider(whintegration.config["wrd:auth"]);
  if(defaultauth.isLoggedIn())
    document.documentElement.classList.add("wh-wrdauth-loggedin");

  dompack.register('.whplugin-wrdauth-logout', node =>
  {
    node.whplugin_processed = true;
    node.addEventListener("click", event =>
    {
      event.stopPropagation();
      event.preventDefault();
      defaultauth.logout();
    });
  });
  dompack.register('.whplugin-wrdauth-loginform', node =>
  {
    node.whplugin_processed = true;
    defaultauth.setupLoginForm(node);
  });

  if(defaultauth.userinfo)
  {
    dompack.register("*[data-wrdauth-text]", node =>
    {
      var elname = node.dataset.wrdauthText;
      if(elname in defaultauth.userinfo)
        node.textContent = defaultauth.userinfo[elname];
    });
    dompack.register("*[data-wrdauth-value]", node =>
    {
      var elname = node.dataset.wrdauthValue;
      if(elname in defaultauth.userinfo)
        node.value = defaultauth.userinfo[elname];
    });
  }
}

module.exports = WRDAuthenticationProvider;



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/wrd/nodejs/auth.es